import { getWeeklyCalorieDeficitMessage } from "@/features/overview/constants/weekly-calorie-deficit";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { IonSkeletonText } from "@ionic/react";
import { memo } from "react";

const formatDeficit = (value: number) => new Intl.NumberFormat("en-GB").format(value);

export const WeeklyCalorieDeficitStatus = memo(function WeeklyCalorieDeficitStatus({
  value,
  isLoading = false,
}: {
  value: number;
  isLoading?: boolean;
}) {
  const message = getWeeklyCalorieDeficitMessage(value);

  if (isLoading) {
    return (
      <div className="flex size-[287px] shrink-0 flex-col items-center justify-center gap-3">
        <IonSkeletonText animated className="h-5 w-48 rounded-lg" />
        <IonSkeletonText animated className="h-[45px] w-52 rounded-xl" />
        <IonSkeletonText animated className="h-5 w-56 rounded-lg" />
      </div>
    );
  }

  return (
    <div className="relative flex size-[287px] shrink-0 flex-col items-center justify-center gap-3 text-center">
      <img
        aria-hidden
        alt=""
        src="/assets/images/onboarding-v5/onboarding-bg-glow.svg"
        className="pointer-events-none absolute inset-0 size-[287px] max-w-none"
      />
      <p className="relative px-[9px] text-center text-xs leading-5 font-semibold text-white">
        YOUR WEEKLY CALORIE DEFICIT
      </p>
      <p
        className="relative w-full text-center text-5xl text-white"
        style={{
          fontFamily: "var(--font-crimson-text)",
          fontWeight: 600,
          lineHeight: "45px",
          letterSpacing: "-1px",
        }}
      >
        {formatDeficit(value)} kcal
      </p>
      <p
        className={cn(textVariants.bodySmall, "relative max-w-[275px] text-center text-white")}
        style={{ lineHeight: "20px" }}
      >
        {message}
      </p>
    </div>
  );
});
